(function ($) {

  $('body').prepend('<a href="#" class="back-to-top"><span class="sr-only">nach oben</span></a>');

  var amountScrolled = 300;

  $(window).scroll(function () {
    if ($(window).scrollTop() > amountScrolled && !$('#content-wrapper').hasClass('menu-open') && !$('#content-wrapper').hasClass('search-open')) {
      $('a.back-to-top').fadeIn('slow');
    } else {
      $('a.back-to-top').fadeOut('slow');
    }
  });

  $('a.back-to-top').click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, 700);

    //PIANO-Usability-Click senden
    try {
      PIANO.UsabilityClick.usabilityClickEvent({
        'type': 'navigation',
        'click': 'Klick auf Back-to-top-Button',
        'click_chapter1': 'Back-to-top',
        'click_chapter3': window.location.origin + window.location.pathname + '#'
      });
    } catch (e) {
      console.warn(e);
    }

    return false;
  });

})(window.jQuery);
